const addEmail = text =>({
    type: 'ADD_EMAIL',
    text: text
})

const delEmail = () => ({
    type: 'DEL_MEAIL',
})

export { addEmail, delEmail }